// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BillingAccountInvoicesTable from "../../modules/Billing/BillingAccountInvoicesTable.res.js";

function SettingsBillingAccountListInvoicesPage(props) {
  let shopId = props.shopId;
  let shops = Auth.useShops();
  let shop = Stdlib_Option.getExn(shops.find(shop => shop.id === shopId), undefined);
  return JsxRuntime.jsx(Page.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(BillingAccountInvoicesTable.make, {
        shopId: shopId,
        invoicesRequest: props.invoicesRequest
      }),
      spaceTop: "medium",
      grow: true
    }),
    title: I18n.t("Invoice history"),
    subtitle: shop.name
  });
}

let make = React.memo(SettingsBillingAccountListInvoicesPage);

export {
  make,
}
/* make Not a pure module */
